import { render, staticRenderFns } from "./FormaPagamento.vue?vue&type=template&id=0f4ac103&"
import script from "./FormaPagamento.vue?vue&type=script&lang=js&"
export * from "./FormaPagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports